/**
 * 标记des中的get、set方法
 * @param descriptor
 */
export function getPrefixByDes(descriptor: TypedPropertyDescriptor<Function>): string {
    let prefix = '';
    if (descriptor?.get) {
        prefix += 'get ';
    }
    if (descriptor?.set) {
        prefix += 'set ';
    }
    return prefix;
}

export function parseTargetKey(targetKey: string): {isGet: boolean, isSet: boolean, name: string} {
    const array = targetKey.split(' ');
    let isGet = false;
    let isSet = false;
    array.forEach((item) => {
        if (item === 'get') isGet = true;
        if (item === 'set') isSet = true;
    });
    return { isGet, isSet, name: array[array.length - 1] };
}
